// @flow
import React, {PureComponent} from 'react';
import ssrWhenTravelingImage from './when-traveling-ssr.png';
import xsWhenTravelingImage from './when-traveling-xs@2x.png';
import whenTravelingImage from './when-traveling@2x.png';

type Props = {useXsImage?: boolean};
type State = {imageSrc: string};

export default class DatesPromptBanerImage extends PureComponent<Props, State> {
    state: State = {
        // use a tiny version of image on ssr.
        // $FlowFixMe
        imageSrc: ssrWhenTravelingImage()
    };

    componentDidMount() {
        // this relies on the fact that componentDidMount does not execute until client render
        // then, larger resolution image src will be used
        this.onModifyImageSrc();
    }
    componentDidUpdate(prevProps: Props) {
        if (prevProps.useXsImage !== this.props.useXsImage) {
            this.onModifyImageSrc();
        }
    }

    onModifyImageSrc = () => {
        this.setState({
            imageSrc: this.props.useXsImage
                ? // $FlowFixMe
                  xsWhenTravelingImage()
                : // $FlowFixMe
                  whenTravelingImage()
        });
    };

    render() {
        return <img alt="" src={this.state.imageSrc} />;
    }
}
